import React from 'react';
import { Container, Grid, Typography, Box } from '@mui/material';
import { ProductCard } from '../components/Products/ProductCard';
import { CloudOutlined, SearchOutlined } from '@mui/icons-material';

export const ProductsPage: React.FC = () => {
  const products = [
    {
      title: 'QixDeploy',
      description: 'Automated deployment platform for modern applications',
      icon: <CloudOutlined sx={{ fontSize: 40, color: 'primary.main' }} />,
      features: [
        'Continuous Integration/Deployment',
        'Container Orchestration',
        'Infrastructure as Code',
        'Monitoring & Logging'
      ]
    },
    {
      title: 'QixScreener',
      description: 'Advanced code analysis and optimization toolkit',
      icon: <SearchOutlined sx={{ fontSize: 40, color: 'primary.main' }} />,
      features: [
        'Static Code Analysis',
        'Performance Optimization',
        'Security Scanning',
        'Code Quality Metrics'
      ]
    }
  ];

  return (
    <Box component="main" sx={{ pt: 12, pb: 8 }}>
      <Container maxWidth="lg">
        <Typography
          component="h1"
          variant="h2"
          align="center"
          color="text.primary"
          gutterBottom
        >
          Our Products
        </Typography>
        <Typography
          variant="h5"
          align="center"
          color="text.secondary"
          paragraph
          sx={{ mb: 6 }}
        >
          Professional tools for modern development workflows
        </Typography>
        <Grid container spacing={4}>
          {products.map((product) => (
            <Grid item key={product.title} xs={12} md={6}>
              <ProductCard {...product} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};